<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="智能测试桩"></a-tab-pane>
        <a-tab-pane key="2" tab="恒电位仪"></a-tab-pane>
      </a-tabs>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :bordered="tableBordered"
        :pagination="false"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (index + 1)  }}
        </span>
        <span slot="pipelineColor" slot-scope="text, record">
          <a-tag :color="record.pipelineColor">{{ record.pipelineColor }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['saifuneng:setup:edit']">
            <a-icon type="edit" />修改
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listSetup } from '@/api/saifuneng/setup'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Setup',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParam: {
        type: null
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '参数名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最小安全值',
          dataIndex: 'limitMin',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '最大安全值',
          dataIndex: 'limitMax',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询设备信息列表 */
    getList () {
      this.loading = true
      listSetup(this.queryParam).then(response => {
        this.list = response.data
        this.loading = false
      })
    },

    // 页签切换
    callback(key) {
      if (key === '1') {
        this.queryParam.type = 1
      } else {
        this.queryParam.type = 2
      }
      this.getList()
    }

  }
}
</script>
